// eslint-disable-next-line import/prefer-default-export
export function getPrice(item) {
    return item.data.price;
}
export function getSalePrice(item) {
    return item.data.sale_price;
}
export function getRolloverImage(item) {
    return item.data.rolloverImage;
}
/* eslint-disable-next-line max-params */
export function getSwatches(item, retrievePrice, retrieveSwatchPreview, retrieveSalePrice, retrieveRolloverImage) {
    const swatchList = [];
    item?.variations?.forEach((variation) => {
        if (retrieveSwatchPreview(variation)) {
            swatchList.push({
                itemName: variation?.itemName || item?.itemName,
                url: variation?.url || item?.url,
                imageUrl: variation?.url,
                variationId: variation?.variationId,
                price: retrievePrice(variation),
                salePrice: retrieveSalePrice(variation),
                swatchPreview: retrieveSwatchPreview(variation),
                rolloverImage: retrieveRolloverImage(variation),
            });
        }
    });
    return swatchList;
}
export function getSwatchPreview(variation) {
    return variation?.data?.swatchPreview;
}
